import type { FormatterMap, RouteList } from '@grandvisionhq/frk-routing'
import { createSimpleFormatter } from '@grandvisionhq/frk-routing'
import { createCheckoutFormatters } from '@grandvisionhq/www-next/formatters'

export const localRouteFormatters: FormatterMap = {
  home: createSimpleFormatter('/'),
  'cart.overview': createSimpleFormatter('cart'),
  'appointments.book': createSimpleFormatter('book-appointment-v3'),
  'appointments.cancel': createSimpleFormatter('cancel-appointment'),
  'appointments.reschedule': createSimpleFormatter('reschedule-appointment'),
  'order.confirm': createSimpleFormatter('order/confirm'),
  ...createCheckoutFormatters({
    path: 'checkout',
    children: { login: 'login', shipping: 'levering', overview: 'oversigt', payment: 'betaling' },
  }),
}

export const routes: RouteList = [
  ['/', 'home'],

  ['/checkout', 'checkout'],
  ['/checkout/callback', 'checkout'],
  ['/checkout/login', 'checkout.login'],
  ['/checkout/levering', 'checkout.shipping'],
  ['/checkout/oversigt', 'checkout.overview'],
  ['/checkout/betaling', 'checkout.payment'],
  ['/api/payment-callback', 'payment.callback'],
  ['/order/confirm', 'order.confirm'],

  ['/express-checkout', 'express-checkout'],

  ['/bestil-tid/(.*)?', 'appointments.book'],
  ['/afbestil-tid', 'appointments.cancel'],
  ['/bestil-ny-tid', 'appointments.reschedule'],
]
